import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { Person } from '../app.component';
import { Spot } from '../app.component';
import { SpotAction } from '../app.component';

import { APIhost } from '../app.component'

@Injectable()
export class SpotService {
	private spotsUrl = APIhost + 'spots.php';

	constructor(private http: Http) { }
	
	getSpots(): Promise<[Spot[]]> {
		const url = `${this.spotsUrl}`;
	  	return this.http.get(url)
	        .toPromise()
			.then(response => {
				var spots = response.json() as [Spot[]];

				for (var i in spots) {
					for (var j in spots[i]) {
						var spot = spots[i][j];
						if (spot.free) {
							spot.action = SpotAction.none;
						}
					}
				}

				return spots;
				
				// return person;
			})
			.catch(this.handleError);
	}

	spotAction(spot: Spot, until: string): Promise<any> {
        var id = localStorage.getItem('selectedUser');
        var url: string;
        switch (spot.action) {
        	case SpotAction.vacate: {
        		url = APIhost + "spotActions.php?action=vacate&id=" + spot.id;
        		break;
        	}
        	case SpotAction.vacateUntil: {
        		url = APIhost + "spotActions.php?action=vacateUntil&until=" + until + "&id=" + spot.id;
        		break;
        	}
        	case SpotAction.cancelVacation: {
        		url = APIhost + "spotActions.php?action=cancelVacation&id=" + spot.id;
        		break;
        	}
        	case SpotAction.none: {
        		return;
        	}
        }

        return this.http.get(url)
            .toPromise()
            .then(response => response)
            .catch(this.handleError);
    }

    reserveSpot(spot: Spot) {
    	var id = localStorage.getItem('selectedUser');
    	var url = APIhost + "spotActions.php?action=assign&user=" + id + "&id=" + spot.id;
    	return this.http.get(url)
            .toPromise()
            .then(response => response)
            .catch(this.handleError);
    }

	private handleError(error: any): Promise<any> {
		console.error('An error occurred', error);
	 	return Promise.reject(error.message || error);
	}
}


// WEBPACK FOOTER //
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/user/spot.service.ts